msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: formatTs(i18n, invitation.expires_at)
#: src/components/InvitationsInbox.tsx
msgid " · Expires {0}"
msgstr " · Expires {0}"

#. placeholder {0}: formatTs(i18n, invitation.decided_at)
#: src/components/InvitationsInbox.tsx
msgid " · Handled {0}"
msgstr " · Handled {0}"

#. placeholder {0}: member.owner_name
#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid " · owned by {0}"
msgstr " · owned by {0}"

#: src/components/ReadOnlyInteraction.tsx
msgid " · Required"
msgstr " · Required"

#: src/components/DescriptionHistoryModal.tsx
msgid ": updated the description"
msgstr ": updated the description"

#. placeholder {0}: formatTs(i18n, invitation.created_at)
#: src/components/InvitationsInbox.tsx
msgid "· Created {0}"
msgstr "· Created {0}"

#. placeholder {0}: preview.channel_count
#. placeholder {1}: preview.thread_count
#: src/components/ServerMemberRemovalControl.tsx
msgid "{0, plural, one {# channel membership} other {# channel memberships}} and {1, plural, one {# thread membership} other {# thread memberships}} will be removed."
msgstr "{0, plural, one {# channel membership} other {# channel memberships}} and {1, plural, one {# thread membership} other {# thread memberships}} will be removed."

#. placeholder {0}: channel.member_count
#: src/components/Settings/ChannelManagementSurface.tsx
msgid "{0, plural, one {# member} other {# members}}"
msgstr "{0, plural, one {# member} other {# members}}"

#. placeholder {0}: onlineUserIds.length
#: src/components/ChannelPresenceList.tsx
msgid "{0, plural, one {# person online} other {# people online}}"
msgstr "{0, plural, one {# person online} other {# people online}}"

#. placeholder {0}: people.length
#: src/components/ProjectMembersPage.tsx
msgid "{0, plural, one {# visible member} other {# visible members}}"
msgstr "{0, plural, one {# visible member} other {# visible members}}"

#. placeholder {0}: tasks.length - MAX_ACTIVE_TASKS_PER_CHANNEL
#: src/components/ChannelList.tsx
msgid "{0, plural, one {+# active task} other {+# active tasks}}"
msgstr "{0, plural, one {+# active task} other {+# active tasks}}"

#. placeholder {0}: member.display_name
#: src/components/MemberProjectProfilePopover.tsx
msgid "{0} Project profile"
msgstr "{0} Project profile"

#: src/components/ZoneChannelGroup.tsx
msgid "{unread} unread in {accessibleName}"
msgstr "{unread} unread in {accessibleName}"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "@Everyone notifies current channel members and is subject to server rate limits."
msgstr "@Everyone notifies current channel members and is subject to server rate limits."

#: src/components/InvitationsInbox.tsx
msgid "← Back"
msgstr "← Back"

#. placeholder {0}: work.active
#: src/components/MemberProjectProfilePopover.tsx
msgid "<0>{0}</0> active"
msgstr "<0>{0}</0> active"

#. placeholder {0}: work.completed
#: src/components/MemberProjectProfilePopover.tsx
msgid "<0>{0}</0> completed"
msgstr "<0>{0}</0> completed"

#. placeholder {0}: work.open
#: src/components/MemberProjectProfilePopover.tsx
msgid "<0>{0}</0> open"
msgstr "<0>{0}</0> open"

#. placeholder {0}: invitation.agent_name || invitation.agent_id
#. placeholder {1}: invitation.channel_name ? `#${invitation.channel_name}` : invitation.channel_id
#: src/components/InvitationsInbox.tsx
msgid "<0>Invite agent</0> <1>{0}</1> to channel <2>{1}</2>"
msgstr "<0>Invite agent</0> <1>{0}</1> to channel <2>{1}</2>"

#. placeholder {0}: zone.name
#: src/components/CreateChannelDialog.tsx
msgid "▦ Zone: {0}"
msgstr "▦ Zone: {0}"

#: src/components/ChannelStatusCard.tsx
msgid "⚫ Offline"
msgstr "⚫ Offline"

#: src/components/MutedChannelIndicator.tsx
msgid "🔕 Muted"
msgstr "🔕 Muted"

#: src/components/ChannelStatusCard.tsx
msgid "🟢 Online"
msgstr "🟢 Online"

#: src/components/ZoneManagementDialog.tsx
msgid "1–100 characters. Names must be distinct within this Project, ignoring case."
msgstr "1–100 characters. Names must be distinct within this Project, ignoring case."

#: src/components/ZoneManagementDialog.tsx
msgid "A Zone with this name already exists. Choose a distinct name."
msgstr "A Zone with this name already exists. Choose a distinct name."

#: src/components/InvitationsInbox.tsx
msgid "Accept"
msgstr "Accept"

#: src/components/InvitationsInbox.tsx
msgid "Accepted"
msgstr "Accepted"

#: src/components/InviteLinksModal.tsx
msgid "Active"
msgstr "Active"

#. placeholder {0}: channel.name
#: src/components/ChannelList.tsx
msgid "Active tasks in {0}"
msgstr "Active tasks in {0}"

#: src/components/AddMemberModal.tsx
msgid "Add"
msgstr "Add"

#: src/components/ProjectMembersPage.tsx
msgid "Add Agent"
msgstr "Add Agent"

#: src/components/AddMemberModal.tsx
#: src/components/MemberList.tsx
#: src/components/ProjectMembersPage.tsx
msgid "Add member"
msgstr "Add member"

#: src/components/ProjectMembersPage.tsx
msgid "Add member options"
msgstr "Add member options"

#: src/components/ServerMembersPanel.tsx
msgid "Add to this channel"
msgstr "Add to this channel"

#: src/components/ProjectMembersPage.tsx
msgid "Admin"
msgstr "Admin"

#: src/components/MemberProjectProfilePopover.tsx
msgid "ADMIN"
msgstr "ADMIN"

#: src/components/ProjectMemberRoleControl.tsx
msgid "Admins can manage ordinary Human and Agent memberships in this Project."
msgstr "Admins can manage ordinary Human and Agent memberships in this Project."

#: src/components/ChannelStatusCard.tsx
#: src/components/ProjectMembersPage.tsx
#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Agent"
msgstr "Agent"

#: src/components/ProjectMembersPage.tsx
msgid "Agent added, but the Project member list could not be refreshed"
msgstr "Agent added, but the Project member list could not be refreshed"

#: src/components/InvitationsInbox.tsx
msgid "Agent invitations"
msgstr "Agent invitations"

#: src/components/InviteLinksModal.tsx
msgid "Agent selection allowed after joining"
msgstr "Agent selection allowed after joining"

#: src/components/ProjectMembersPage.tsx
msgid "Agents"
msgstr "Agents"

#: src/components/ChannelFilterSidebar.tsx
#: src/components/InvitationsInbox.tsx
#: src/components/ProjectMembersPage.tsx
msgid "All"
msgstr "All"

#: src/components/NotificationPrefDropdown.tsx
msgid "All messages"
msgstr "All messages"

#: src/components/InviteLinksModal.tsx
msgid "Allow invited Humans to choose their active agents"
msgstr "Allow invited Humans to choose their active agents"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Allow messages without mentions"
msgstr "Allow messages without mentions"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "An @mention is currently required"
msgstr "An @mention is currently required"

#: src/components/InviteLinksModal.tsx
msgid "Anyone who has not accepted it will no longer be able to join."
msgstr "Anyone who has not accepted it will no longer be able to join."

#: src/components/MemberProjectProfilePopover.tsx
msgid "APP"
msgstr "APP"

#: src/components/ChannelSettingsModal.tsx
msgid "Archive failed"
msgstr "Archive failed"

#: src/components/ArchivedChannelsPanel.tsx
#: src/components/ChannelRow.tsx
msgid "Archived"
msgstr "Archived"

#: src/components/ArchivedChannelsPanel.tsx
msgid "Archived channels"
msgstr "Archived channels"

#: src/components/ZoneManagementDialog.tsx
msgid "Archived channels also prevent deletion. No channel will be deleted or reassigned."
msgstr "Archived channels also prevent deletion. No channel will be deleted or reassigned."

#: src/components/MemberProjectProfilePopover.tsx
msgid "Assigned"
msgstr "Assigned"

#: src/components/ChannelSettingsModal.tsx
msgid "Assigned at creation. Placement is read-only and does not affect channel access."
msgstr "Assigned at creation. Placement is read-only and does not affect channel access."

#: src/components/TurnRoutingPolicyControl.tsx
msgid "Borgee decides eligible turns"
msgstr "Borgee decides eligible turns"

#: src/components/TurnRoutingPolicyControl.tsx
msgid "Borgee decides when eligible agents receive a turn in this channel."
msgstr "Borgee decides when eligible agents receive a turn in this channel."

#: src/components/TurnRoutingPolicyControl.tsx
msgid "Borgee decides when eligible agents receive a turn. In 1H+1A with mentions off, ordinary human messages give the agent a turn; otherwise explicit @ targets do. Threads have independent policies."
msgstr "Borgee decides when eligible agents receive a turn. In 1H+1A with mentions off, ordinary human messages give the agent a turn; otherwise explicit @ targets do. Threads have independent policies."

#: src/components/TurnRoutingPolicyControl.tsx
msgid "Borgee turn routing"
msgstr "Borgee turn routing"

#: src/components/ZoneManagementDialog.tsx
msgid "Built-in"
msgstr "Built-in"

#: src/components/AddMemberModal.tsx
#: src/components/ChannelSettingsModal.tsx
#: src/components/CreateChannelDialog.tsx
#: src/components/CreateServerModal.tsx
#: src/components/DescriptionEditor.tsx
#: src/components/InviteLinksModal.tsx
#: src/components/KickConfirmModal.tsx
#: src/components/ProjectMemberRoleControl.tsx
#: src/components/ProjectMembersPage.tsx
#: src/components/ServerMemberRemovalControl.tsx
#: src/components/ServerSettings/ServerMembersPanel.tsx
#: src/components/ZoneManagementDialog.tsx
msgid "Cancel"
msgstr "Cancel"

#: src/components/HumanDetailView.tsx
msgid "Cannot open chat."
msgstr "Cannot open chat."

#: src/components/ProjectMemberRoleControl.tsx
msgid "Change {displayName} Project role"
msgstr "Change {displayName} Project role"

#. placeholder {0}: channelDisplayName(target)
#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Channel #{0} was deleted."
msgstr "Channel #{0} was deleted."

#: src/components/ChannelSettingsModal.tsx
msgid "Channel archived"
msgstr "Channel archived"

#: src/stores/useChannelStore.ts
msgid "Channel created, but its permissions could not be refreshed."
msgstr "Channel created, but its permissions could not be refreshed."

#: src/components/ChannelSettingsModal.tsx
msgid "Channel deleted"
msgstr "Channel deleted"

#: src/components/DescriptionEditor.tsx
msgid "Channel description"
msgstr "Channel description"

#: src/components/DescriptionEditor.tsx
msgid "Channel descriptions must be {DESCRIPTION_MAX_LENGTH} characters or fewer."
msgstr "Channel descriptions must be {DESCRIPTION_MAX_LENGTH} characters or fewer."

#: src/components/ChannelSettingsModal.tsx
msgid "Channel is now private."
msgstr "Channel is now private."

#: src/components/ChannelSettingsModal.tsx
msgid "Channel is now public."
msgstr "Channel is now public."

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Channel management"
msgstr "Channel management"

#: src/components/ChannelSettingsModal.tsx
msgid "Channel moved."
msgstr "Channel moved."

#: src/components/CreateChannelDialog.tsx
msgid "Channel name"
msgstr "Channel name"

#: src/components/ChannelSettingsModal.tsx
msgid "Channel name confirmation"
msgstr "Channel name confirmation"

#: src/components/ChannelView.tsx
msgid "Channel not found"
msgstr "Channel not found"

#: src/components/ChannelSettingsModal.tsx
msgid "Channel restored"
msgstr "Channel restored"

#: src/lib/readonly.ts
msgid "Channel set to read-only"
msgstr "Channel set to read-only"

#: src/components/ChannelView.tsx
msgid "Channel Settings"
msgstr "Channel Settings"

#: src/components/ChannelSettingsModal.tsx
msgid "Channel updated"
msgstr "Channel updated"

#: src/components/ChannelSettingsModal.tsx
msgid "Channel Zone"
msgstr "Channel Zone"

#: src/components/Sidebar.tsx
msgid "Channels"
msgstr "Channels"

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Channels I created"
msgstr "Channels I created"

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Channels I joined"
msgstr "Channels I joined"

#: src/components/ChannelSettingsModal.tsx
msgid "Channels in a named Zone stay in their original Project. Placement cannot be changed."
msgstr "Channels in a named Zone stay in their original Project. Placement cannot be changed."

#: src/components/ChannelView.tsx
#: src/components/HumanDetailView.tsx
msgid "Chat"
msgstr "Chat"

#: src/components/CreateChannelDialog.tsx
msgid "Choose Default or a named Zone. The channel’s visibility and membership stay independent."
msgstr "Choose Default or a named Zone. The channel’s visibility and membership stay independent."

#: src/components/ProjectMembersPage.tsx
msgid "Choose one of your active Agents to add to this Project."
msgstr "Choose one of your active Agents to add to this Project."

#: src/components/DescriptionHistoryModal.tsx
#: src/components/InviteLinksModal.tsx
msgid "Close"
msgstr "Close"

#: src/components/KickConfirmModal.tsx
msgid "Confirm"
msgstr "Confirm"

#: src/components/InviteLinksModal.tsx
msgid "Copied"
msgstr "Copied"

#: src/components/InviteLinksModal.tsx
msgid "Copy invite link"
msgstr "Copy invite link"

#: src/components/AddMemberModal.tsx
msgid "Could not add member."
msgstr "Could not add member."

#: src/components/ProjectMembersPage.tsx
msgid "Could not add the Agent"
msgstr "Could not add the Agent"

#: src/components/ProjectMembersPage.tsx
msgid "Could not add the agent to this Project."
msgstr "Could not add the agent to this Project."

#: src/components/ReadonlyToggle.tsx
msgid "Could not change read-only setting."
msgstr "Could not change read-only setting."

#: src/components/ProjectMemberRoleControl.tsx
msgid "Could not change this Project role."
msgstr "Could not change this Project role."

#: src/components/InvitationsInbox.tsx
msgid "Could not complete the action."
msgstr "Could not complete the action."

#: src/components/InviteLinksModal.tsx
msgid "Could not copy the invite link. Copy it manually before closing this dialog."
msgstr "Could not copy the invite link. Copy it manually before closing this dialog."

#: src/components/InviteLinksModal.tsx
msgid "Could not create invite link."
msgstr "Could not create invite link."

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Could not delete channel."
msgstr "Could not delete channel."

#: src/components/ArchivedChannelsPanel.tsx
#: src/components/InvitationsInbox.tsx
msgid "Could not load data."
msgstr "Could not load data."

#: src/components/DescriptionHistoryModal.tsx
msgid "Could not load edit history."
msgstr "Could not load edit history."

#: src/components/InviteLinksModal.tsx
msgid "Could not load invite links."
msgstr "Could not load invite links."

#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Could not load members."
msgstr "Could not load members."

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Could not load mention settings."
msgstr "Could not load mention settings."

#: src/components/ProjectMembersPage.tsx
msgid "Could not load your Agents"
msgstr "Could not load your Agents"

#: src/components/ProjectMembersPage.tsx
msgid "Could not load your agents."
msgstr "Could not load your agents."

#: src/components/ZoneManagementDialog.tsx
msgid "Could not load Zones. Refresh Zones to load the current groups."
msgstr "Could not load Zones. Refresh Zones to load the current groups."

#: src/components/ServerMemberRemovalControl.tsx
msgid "Could not preview removal."
msgstr "Could not preview removal."

#: src/stores/useChannelStore.ts
msgid "Could not refresh channels and Zones."
msgstr "Could not refresh channels and Zones."

#: src/components/ZoneManagementDialog.tsx
msgid "Could not refresh Zones. Please try again."
msgstr "Could not refresh Zones. Please try again."

#: src/components/KickConfirmModal.tsx
#: src/components/ServerMemberRemovalControl.tsx
#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Could not remove member."
msgstr "Could not remove member."

#: src/components/ArchivedChannelsPanel.tsx
msgid "Could not restore channel."
msgstr "Could not restore channel."

#: src/components/InviteLinksModal.tsx
msgid "Could not revoke invite link."
msgstr "Could not revoke invite link."

#: src/components/DescriptionEditor.tsx
msgid "Could not save channel description."
msgstr "Could not save channel description."

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Could not save Project settings."
msgstr "Could not save Project settings."

#: src/components/ZoneManagementDialog.tsx
msgid "Could not save this change. Please try again."
msgstr "Could not save this change. Please try again."

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Could not update mention policy."
msgstr "Could not update mention policy."

#: src/components/InviteLinksModal.tsx
msgid "Create and copy invite link"
msgstr "Create and copy invite link"

#: src/components/CreateChannelDialog.tsx
#: src/components/Sidebar.tsx
msgid "Create channel"
msgstr "Create channel"

#: src/components/Sidebar.tsx
msgid "Create Channel"
msgstr "Create Channel"

#: src/components/ZoneChannelGroup.tsx
msgid "Create channel in {accessibleName}"
msgstr "Create channel in {accessibleName}"

#: src/components/CreateServerModal.tsx
#: src/components/PrimaryNavigationRail.tsx
msgid "Create Project"
msgstr "Create Project"

#: src/components/Sidebar.tsx
#: src/components/ZoneManagementDialog.tsx
msgid "Create Zone"
msgstr "Create Zone"

#: src/components/MemberProjectProfilePopover.tsx
msgid "Created"
msgstr "Created"

#: src/components/CreateChannelDialog.tsx
msgid "Creating…"
msgstr "Creating…"

#: src/components/MemberProjectProfilePopover.tsx
msgid "Current focus"
msgstr "Current focus"

#: src/components/ServerSidebar.tsx
msgid "Current Project"
msgstr "Current Project"

#: src/components/InvitationsInbox.tsx
msgid "Decline"
msgstr "Decline"

#: src/components/InvitationsInbox.tsx
msgid "Declined"
msgstr "Declined"

#: src/components/ChannelSettingsModal.tsx
#: src/components/CreateChannelDialog.tsx
#: src/components/ZoneManagementDialog.tsx
msgid "Default (no Zone)"
msgstr "Default (no Zone)"

#: src/components/CreateChannelDialog.tsx
msgid "Default is the ungrouped location. Placement cannot be changed after creation."
msgstr "Default is the ungrouped location. Placement cannot be changed after creation."

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Default is the virtual location for channels with no named Zone. Project members can see all named Zones, including empty ones."
msgstr "Default is the virtual location for channels with no named Zone. Project members can see all named Zones, including empty ones."

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Delete"
msgstr "Delete"

#. placeholder {0}: channelDisplayName(channel!)
#: src/components/ChannelSettingsModal.tsx
msgid "Delete #{0}"
msgstr "Delete #{0}"

#: src/components/ZoneManagementDialog.tsx
msgid "Delete <0>{selectedName}</0> from this Project. Only an empty Zone can be deleted."
msgstr "Delete <0>{selectedName}</0> from this Project. Only an empty Zone can be deleted."

#. placeholder {0}: channelDisplayName(channel)
#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Delete channel #{0}"
msgstr "Delete channel #{0}"

#: src/components/ChannelSettingsModal.tsx
msgid "Delete failed"
msgstr "Delete failed"

#: src/components/ZoneChannelGroup.tsx
#: src/components/ZoneManagementDialog.tsx
msgid "Delete Zone"
msgstr "Delete Zone"

#. placeholder {0}: zone.name
#: src/components/ZoneManagementDialog.tsx
msgid "Delete Zone: {0}"
msgstr "Delete Zone: {0}"

#: src/components/ZoneManagementDialog.tsx
msgid "Delete Zone?"
msgstr "Delete Zone?"

#: src/components/ProjectMemberRoleControl.tsx
msgid "Demote to Member"
msgstr "Demote to Member"

#: src/components/CreateChannelDialog.tsx
msgid "Description (optional)"
msgstr "Description (optional)"

#: src/components/ChannelSettingsModal.tsx
msgid "Description <0>(optional)</0>"
msgstr "Description <0>(optional)</0>"

#: src/components/Sidebar.tsx
msgid "Direct Messages"
msgstr "Direct Messages"

#: src/components/HumanDetailView.tsx
msgid "DISPLAY NAME"
msgstr "DISPLAY NAME"

#: src/components/Sidebar.tsx
msgid "DM"
msgstr "DM"

#: src/components/NotificationPrefDropdown.tsx
msgid "Do not disturb"
msgstr "Do not disturb"

#: src/components/ZoneManagementDialog.tsx
msgid "e.g. Customer experience"
msgstr "e.g. Customer experience"

#: src/components/ChannelHeader.tsx
msgid "Edit"
msgstr "Edit"

#: src/components/ChannelSettingsModal.tsx
msgid "EDIT CHANNEL"
msgstr "EDIT CHANNEL"

#: src/components/DescriptionHistoryModal.tsx
msgid "Edit history"
msgstr "Edit history"

#: src/lib/readonly.ts
msgid "Editing restored"
msgstr "Editing restored"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Emoji or short text"
msgstr "Emoji or short text"

#: src/components/TurnRoutingPolicyControl.tsx
msgid "Enable Borgee turn routing for this channel"
msgstr "Enable Borgee turn routing for this channel"

#: src/lib/zoneNames.ts
msgid "Enter a Zone name."
msgstr "Enter a Zone name."

#: src/components/ZoneChannelGroup.tsx
msgid "Expanded for the selected channel"
msgstr "Expanded for the selected channel"

#: src/components/InvitationsInbox.tsx
#: src/components/InviteLinksModal.tsx
msgid "Expired"
msgstr "Expired"

#: src/components/ServerMembersPanel.tsx
msgid "Failed to add member"
msgstr "Failed to add member"

#: src/components/CreateChannelDialog.tsx
msgid "Failed to create channel"
msgstr "Failed to create channel"

#: src/components/ChannelView.tsx
msgid "Failed to join"
msgstr "Failed to join"

#: src/components/ChannelView.tsx
msgid "Failed to leave"
msgstr "Failed to leave"

#: src/components/TurnRoutingPolicyControl.tsx
msgid "Failed to load Borgee turn routing"
msgstr "Failed to load Borgee turn routing"

#: src/components/ServerMembersPanel.tsx
msgid "Failed to load channel members."
msgstr "Failed to load channel members."

#: src/components/ChannelSettingsModal.tsx
msgid "Failed to move channel"
msgstr "Failed to move channel"

#: src/components/CreateChannelDialog.tsx
msgid "Failed to refresh Zones"
msgstr "Failed to refresh Zones"

#: src/components/ServerMembersPanel.tsx
msgid "Failed to remove member"
msgstr "Failed to remove member"

#: src/components/ChannelSettingsModal.tsx
msgid "Failed to save"
msgstr "Failed to save"

#: src/components/ChannelSettingsModal.tsx
msgid "Failed to switch"
msgstr "Failed to switch"

#: src/components/TurnRoutingPolicyControl.tsx
msgid "Failed to update Borgee turn routing"
msgstr "Failed to update Borgee turn routing"

#: src/components/ServerMembersPanel.tsx
msgid "Failed to update policy"
msgstr "Failed to update policy"

#: src/components/ChannelView.tsx
msgid "Files"
msgstr "Files"

#: src/components/ServerSettings/ServerProfilePanel.tsx
#: src/components/ServerSettingsSidebar.tsx
msgid "General"
msgstr "General"

#: src/components/ZoneManagementDialog.tsx
msgid "Group related channels in the sidebar. A Zone does not change channel access or add members."
msgstr "Group related channels in the sidebar. A Zone does not change channel access or add members."

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Group related channels in the sidebar. Channel access and membership remain independent."
msgstr "Group related channels in the sidebar. Channel access and membership remain independent."

#. placeholder {0}: channelDisplayName(channel!)
#: src/components/ChannelSettingsModal.tsx
msgid "Hide #{0}"
msgstr "Hide #{0}"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Hide mention settings"
msgstr "Hide mention settings"

#: src/components/HumanDetailView.tsx
#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Human"
msgstr "Human"

#: src/components/ProjectMembersPage.tsx
msgid "Humans"
msgstr "Humans"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "ICON"
msgstr "ICON"

#: src/components/CreateServerModal.tsx
msgid "Icon (optional)"
msgstr "Icon (optional)"

#: src/lib/createServer.ts
msgid "Icon must be 500 characters or fewer."
msgstr "Icon must be 500 characters or fewer."

#. placeholder {0}: inChannel.length
#: src/components/ServerMembersPanel.tsx
msgid "In this channel — {0}"
msgstr "In this channel — {0}"

#: src/components/MemberProjectProfilePopover.tsx
msgid "In this Project"
msgstr "In this Project"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Inherit agent settings"
msgstr "Inherit agent settings"

#: src/components/ChannelView.tsx
#: src/components/ServerSidebar.tsx
msgid "Insights"
msgstr "Insights"

#: src/components/ProjectMembersPage.tsx
msgid "Invite human"
msgstr "Invite human"

#: src/components/InviteLinksModal.tsx
msgid "Invite link copied. It is shown here only until this dialog closes."
msgstr "Invite link copied. It is shown here only until this dialog closes."

#: src/components/InviteLinksModal.tsx
msgid "Invite link history"
msgstr "Invite link history"

#: src/components/InviteLinksModal.tsx
msgid "Invite members"
msgstr "Invite members"

#. placeholder {0}: invitation.requester_name || invitation.requested_by
#: src/components/InvitationsInbox.tsx
msgid "Invited by <0>{0}</0>"
msgstr "Invited by <0>{0}</0>"

#. placeholder {0}: channelDisplayName(channel!)
#: src/components/ChannelView.tsx
msgid "Join #{0} to reply"
msgstr "Join #{0} to reply"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Join this channel to view member mention settings."
msgstr "Join this channel to view member mention settings."

#: src/components/MemberProjectProfilePopover.tsx
msgid "Joined {joined}"
msgstr "Joined {joined}"

#: src/components/ChannelView.tsx
msgid "Joining..."
msgstr "Joining..."

#: src/components/ChannelView.tsx
msgid "Leave"
msgstr "Leave"

#: src/components/ChannelView.tsx
msgid "Leave channel"
msgstr "Leave channel"

#: src/components/InviteLinksModal.tsx
msgid "Let invited Humans choose their active agents after joining"
msgstr "Let invited Humans choose their active agents after joining"

#: src/components/MemberProjectProfilePopover.tsx
msgid "Loading authorized task context…"
msgstr "Loading authorized task context…"

#: src/components/Sidebar.tsx
msgid "Loading channels and Zones…"
msgstr "Loading channels and Zones…"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Loading Project settings…"
msgstr "Loading Project settings…"

#: src/components/ServerMemberRemovalControl.tsx
msgid "Loading removal impact…"
msgstr "Loading removal impact…"

#: src/components/ProjectMembersPage.tsx
msgid "Loading your Agents…"
msgstr "Loading your Agents…"

#: src/components/ZoneManagementDialog.tsx
msgid "Loading Zones…"
msgstr "Loading Zones…"

#: src/components/ArchivedChannelsPanel.tsx
#: src/components/Settings/ChannelMentionControls.tsx
msgid "Loading…"
msgstr "Loading…"

#. placeholder {0}: member.display_name
#: src/components/ProjectMembersPage.tsx
msgid "Manage {0}"
msgstr "Manage {0}"

#: src/components/ZoneChannelGroup.tsx
msgid "Manage {accessibleName}"
msgstr "Manage {accessibleName}"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Manage Zones"
msgstr "Manage Zones"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Managing channel members is required to change agent mention policies."
msgstr "Managing channel members is required to change agent mention policies."

#: src/components/ProjectMembersPage.tsx
msgid "Member"
msgstr "Member"

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Member count unavailable"
msgstr "Member count unavailable"

#: src/components/ChannelView.tsx
#: src/components/MemberList.tsx
#: src/components/ProjectMembersPage.tsx
#: src/components/ServerSidebar.tsx
msgid "Members"
msgstr "Members"

#: src/components/ChannelSettingsModal.tsx
msgid "Members, invitations, layouts, and other access derived from the current Project are removed. Only your new owner access is created in the target Project."
msgstr "Members, invitations, layouts, and other access derived from the current Project are removed. Only your new owner access is created in the target Project."

#. placeholder {0}: members.length
#. placeholder {1}: online.length
#: src/components/ChannelStatusCard.tsx
msgid "Members: {0} (online {1})"
msgstr "Members: {0} (online {1})"

#. placeholder {0}: agent.display_name
#: src/components/Settings/ChannelMentionControls.tsx
msgid "Mention policy for {0}"
msgstr "Mention policy for {0}"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Mention settings"
msgstr "Mention settings"

#: src/components/NotificationPrefDropdown.tsx
msgid "Mentions only"
msgstr "Mentions only"

#. placeholder {0}: user.display_name
#: src/components/Sidebar.tsx
msgid "Message {0}"
msgstr "Message {0}"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Messages without mentions are also delivered"
msgstr "Messages without mentions are also delivered"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Messages without mentions are delivered only when the agent owner allows them."
msgstr "Messages without mentions are delivered only when the agent owner allows them."

#. placeholder {0}: channelDisplayName(channel!)
#: src/components/ChannelSettingsModal.tsx
msgid "Move #{0}"
msgstr "Move #{0}"

#. placeholder {0}: channelDisplayName(channel)
#: src/components/ChannelSettingsModal.tsx
msgid "Move #{0} to another Project"
msgstr "Move #{0} to another Project"

#: src/components/ChannelSettingsModal.tsx
msgid "Move channel"
msgstr "Move channel"

#: src/components/ChannelSettingsModal.tsx
msgid "Move to another Project"
msgstr "Move to another Project"

#: src/components/MuteButton.tsx
msgid "Mute"
msgstr "Mute"

#: src/components/MutedChannelIndicator.tsx
msgid "Muted"
msgstr "Muted"

#: src/components/PrimaryNavigationRail.tsx
msgid "My Agents"
msgstr "My Agents"

#: src/components/PrimaryNavigationRail.tsx
msgid "My Computers"
msgstr "My Computers"

#: src/components/PrimaryNavigationRail.tsx
msgid "My Tasks"
msgstr "My Tasks"

#: src/components/ChannelSettingsModal.tsx
msgid "Name"
msgstr "Name"

#: src/components/ZoneManagementDialog.tsx
msgid "Named groups for this Project’s channels. Channel permissions are managed on each channel."
msgstr "Named groups for this Project’s channels. Channel permissions are managed on each channel."

#: src/components/ZoneManagementDialog.tsx
msgid "Named Zone"
msgstr "Named Zone"

#: src/lib/zoneNames.ts
msgid "Names cannot contain control characters."
msgstr "Names cannot contain control characters."

#: src/components/Settings/ChannelMentionControls.tsx
msgid "No agent members need individual settings."
msgstr "No agent members need individual settings."

#: src/components/InviteLinksModal.tsx
msgid "No agent selection"
msgstr "No agent selection"

#: src/components/ArchivedChannelsPanel.tsx
msgid "No archived channels"
msgstr "No archived channels"

#: src/components/ServerMemberRemovalControl.tsx
msgid "no channel memberships"
msgstr "no channel memberships"

#: src/components/ChannelList.tsx
msgid "No channels"
msgstr "No channels"

#: src/components/DescriptionHistoryModal.tsx
msgid "No edit history"
msgstr "No edit history"

#: src/components/ProjectMembersPage.tsx
msgid "No eligible Agents are available."
msgstr "No eligible Agents are available."

#: src/components/InvitationsInbox.tsx
msgid "No invitations"
msgstr "No invitations"

#: src/components/InviteLinksModal.tsx
msgid "No invite links yet."
msgstr "No invite links yet."

#: src/components/ProjectMembersPage.tsx
msgid "No matching members."
msgstr "No matching members."

#: src/components/ServerMembersPanel.tsx
msgid "No members yet"
msgstr "No members yet"

#: src/components/MemberProjectProfilePopover.tsx
msgid "No open work in the authorized task view."
msgstr "No open work in the authorized task view."

#: src/components/InvitationsInbox.tsx
msgid "No pending invitations"
msgstr "No pending invitations"

#: src/components/ServerSidebar.tsx
msgid "No Project selected"
msgstr "No Project selected"

#: src/components/ZoneChannelGroup.tsx
msgid "No visible channels"
msgstr "No visible channels"

#: src/components/ChannelStatusCard.tsx
msgid "None"
msgstr "None"

#: src/components/ServerMembersPanel.tsx
msgid "Not in this channel"
msgstr "Not in this channel"

#: src/components/NotificationPrefDropdown.tsx
msgid "Notification preference"
msgstr "Notification preference"

#: src/components/CreateChannelDialog.tsx
msgid "Only invited members can see this channel."
msgstr "Only invited members can see this channel."

#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Only the Project owner can manage members."
msgstr "Only the Project owner can manage members."

#: src/components/ProjectMembersPage.tsx
msgid "Open direct message"
msgstr "Open direct message"

#. placeholder {0}: member.display_name
#: src/components/ProjectMembersPage.tsx
msgid "Open direct message with {0}"
msgstr "Open direct message with {0}"

#: src/components/PrimaryNavigationRail.tsx
msgid "Overview"
msgstr "Overview"

#: src/components/ProjectMembersPage.tsx
msgid "Owner"
msgstr "Owner"

#: src/components/MemberProjectProfilePopover.tsx
msgid "OWNER"
msgstr "OWNER"

#: src/components/MemberProjectProfilePopover.tsx
msgid "Participant"
msgstr "Participant"

#: src/components/InvitationsInbox.tsx
msgid "Pending"
msgstr "Pending"

#: src/components/ProjectMembersPage.tsx
msgid "People"
msgstr "People"

#: src/components/ReadOnlyInteraction.tsx
msgid "Permission request"
msgstr "Permission request"

#: src/components/PrimaryNavigationRail.tsx
msgid "Personal navigation"
msgstr "Personal navigation"

#: src/components/PrimaryNavigationRail.tsx
msgid "Personal resources"
msgstr "Personal resources"

#: src/components/ChannelContextMenu.tsx
#: src/components/PinButton.tsx
msgid "Pin"
msgstr "Pin"

#: src/components/ChannelRow.tsx
msgid "Pinned"
msgstr "Pinned"

#: src/components/PinnedChannelsSection.tsx
msgid "Pinned channels"
msgstr "Pinned channels"

#: src/components/ReadOnlyInteraction.tsx
msgid "Plan approval"
msgstr "Plan approval"

#: src/components/ChannelSettingsModal.tsx
#: src/components/CreateChannelDialog.tsx
#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Private"
msgstr "Private"

#: src/components/ChannelRow.tsx
#: src/components/ChannelView.tsx
msgid "Private channel"
msgstr "Private channel"

#: src/components/InvitationsInbox.tsx
msgid "Processing…"
msgstr "Processing…"

#: src/components/HumanDetailView.tsx
msgid "Profile"
msgstr "Profile"

#: src/components/ProjectPageHeader.tsx
msgid "Project"
msgstr "Project"

#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Project access is no longer available."
msgstr "Project access is no longer available."

#: src/components/ProjectMembersPage.tsx
msgid "Project members"
msgstr "Project members"

#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Project Members"
msgstr "Project Members"

#: src/components/CreateChannelDialog.tsx
msgid "Project members can preview and join."
msgstr "Project members can preview and join."

#: src/components/ZoneManagementDialog.tsx
msgid "Project members can see the Zone, including when it has no channels."
msgstr "Project members can see the Zone, including when it has no channels."

#: src/components/ServerMemberRemovalControl.tsx
msgid "PROJECT MEMBERSHIP"
msgstr "PROJECT MEMBERSHIP"

#: src/components/CreateServerModal.tsx
msgid "Project name"
msgstr "Project name"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "PROJECT NAME"
msgstr "PROJECT NAME"

#: src/components/ServerSettings/ServerProfilePanel.tsx
#: src/lib/createServer.ts
msgid "Project name is required."
msgstr "Project name is required."

#: src/lib/createServer.ts
msgid "Project name must be 100 characters or fewer."
msgstr "Project name must be 100 characters or fewer."

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Project profile"
msgstr "Project profile"

#: src/components/ServerSidebar.tsx
msgid "Project resources"
msgstr "Project resources"

#: src/components/ServerSettings/ServerProfilePanel.tsx
#: src/components/ServerSettingsSidebar.tsx
msgid "Project Settings"
msgstr "Project Settings"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Project settings access denied"
msgstr "Project settings access denied"

#: src/components/PrimaryNavigationRail.tsx
msgid "Projects"
msgstr "Projects"

#: src/components/ProjectMemberRoleControl.tsx
msgid "Promote to Admin"
msgstr "Promote to Admin"

#: src/components/ChannelSettingsModal.tsx
#: src/components/CreateChannelDialog.tsx
#: src/components/Settings/ChannelManagementSurface.tsx
msgid "Public"
msgstr "Public"

#: src/components/ChannelList.tsx
msgid "Public channels"
msgstr "Public channels"

#: src/components/ChannelRow.tsx
#: src/components/ChannelView.tsx
#: src/components/ReadonlyBadge.tsx
msgid "Read-only"
msgstr "Read-only"

#: src/components/ReadonlyBadge.tsx
msgid "Read-only channel"
msgstr "Read-only channel"

#: src/components/ChannelSettingsModal.tsx
msgid "Read-only placement"
msgstr "Read-only placement"

#: src/components/ReadOnlyInteraction.tsx
msgid "Read-only request"
msgstr "Read-only request"

#: src/components/MemberProjectProfilePopover.tsx
msgid "Recent work"
msgstr "Recent work"

#: src/components/InvitationsInbox.tsx
msgid "Refresh"
msgstr "Refresh"

#: src/components/CreateChannelDialog.tsx
#: src/components/ZoneManagementDialog.tsx
msgid "Refresh Zones"
msgstr "Refresh Zones"

#: src/components/CreateChannelDialog.tsx
msgid "Refreshing…"
msgstr "Refreshing…"

#: src/components/ServerMemberRemovalControl.tsx
msgid "Removal impact is unavailable."
msgstr "Removal impact is unavailable."

#: src/components/MemberList.tsx
#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Remove"
msgstr "Remove"

#. placeholder {0}: target.display_name
#. placeholder {0}: user.display_name
#: src/components/KickConfirmModal.tsx
#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Remove {0}?"
msgstr "Remove {0}?"

#: src/components/ServerMemberRemovalControl.tsx
msgid "Remove {displayName} from Project"
msgstr "Remove {displayName} from Project"

#: src/components/ServerMemberRemovalControl.tsx
msgid "Remove {displayName} from this Project?"
msgstr "Remove {displayName} from this Project?"

#: src/components/ServerMemberRemovalControl.tsx
msgid "Remove Agent"
msgstr "Remove Agent"

#: src/components/ServerMemberRemovalControl.tsx
msgid "Remove from Project"
msgstr "Remove from Project"

#: src/components/ServerMembersPanel.tsx
msgid "Remove from this channel"
msgstr "Remove from this channel"

#: src/components/ServerMemberRemovalControl.tsx
msgid "Remove Human and access"
msgstr "Remove Human and access"

#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Remove member"
msgstr "Remove member"

#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "Removing a member only removes their Project access. Their channel and thread memberships are not changed."
msgstr "Removing a member only removes their Project access. Their channel and thread memberships are not changed."

#: src/components/ZoneChannelGroup.tsx
#: src/components/ZoneManagementDialog.tsx
msgid "Rename Zone"
msgstr "Rename Zone"

#. placeholder {0}: zone.name
#: src/components/ZoneManagementDialog.tsx
msgid "Rename Zone: {0}"
msgstr "Rename Zone: {0}"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Require an explicit @mention"
msgstr "Require an explicit @mention"

#: src/components/ArchivedChannelsPanel.tsx
msgid "Restore"
msgstr "Restore"

#. placeholder {0}: channelDisplayName(channel!)
#: src/components/ChannelSettingsModal.tsx
msgid "Restore #{0}"
msgstr "Restore #{0}"

#: src/components/CreateServerModal.tsx
#: src/components/ProjectMembersPage.tsx
#: src/components/Sidebar.tsx
msgid "Retry"
msgstr "Retry"

#: src/components/ProjectMembersPage.tsx
msgid "Retry refresh"
msgstr "Retry refresh"

#: src/components/InviteLinksModal.tsx
msgid "Revoke"
msgstr "Revoke"

#: src/components/InviteLinksModal.tsx
msgid "Revoke invite link"
msgstr "Revoke invite link"

#: src/components/InviteLinksModal.tsx
msgid "Revoke link"
msgstr "Revoke link"

#: src/components/InviteLinksModal.tsx
msgid "Revoke this invite link?"
msgstr "Revoke this invite link?"

#: src/components/InviteLinksModal.tsx
msgid "Revoked"
msgstr "Revoked"

#: src/components/DescriptionEditor.tsx
msgid "Save"
msgstr "Save"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Save changes"
msgstr "Save changes"

#: src/components/ChannelSettingsModal.tsx
msgid "Save Changes"
msgstr "Save Changes"

#: src/components/ZoneManagementDialog.tsx
msgid "Save name"
msgstr "Save name"

#: src/components/ChannelSearchInput.tsx
msgid "Search channels"
msgstr "Search channels"

#: src/components/ProjectMembersPage.tsx
msgid "Search members"
msgstr "Search members"

#: src/components/ProjectMembersPage.tsx
msgid "Search people…"
msgstr "Search people…"

#: src/components/CreateChannelDialog.tsx
msgid "Select members (optional)"
msgstr "Select members (optional)"

#: src/components/ServerSettings/ServerProfilePanel.tsx
#: src/components/ServerSidebar.tsx
msgid "Settings"
msgstr "Settings"

#: src/components/InviteLinksModal.tsx
msgid "Share a link to admit a Human to this Project. Invite URLs are never kept in this browser."
msgstr "Share a link to admit a Human to this Project. Invite URLs are never kept in this browser."

#. placeholder {0}: guild.name
#: src/components/PrimaryNavigationRail.tsx
msgid "Switch to {0}"
msgstr "Switch to {0}"

#: src/components/ChannelSettingsModal.tsx
msgid "Switch to Private"
msgstr "Switch to Private"

#: src/components/ChannelSettingsModal.tsx
msgid "Switch to Public"
msgstr "Switch to Public"

#: src/components/ChannelSettingsModal.tsx
msgid "Target Project"
msgstr "Target Project"

#: src/components/MemberProjectProfilePopover.tsx
msgid "Task context is unavailable right now."
msgstr "Task context is unavailable right now."

#: src/components/MemberProjectProfilePopover.tsx
msgid "Task contribution summary"
msgstr "Task contribution summary"

#: src/components/ChannelView.tsx
#: src/components/ServerSidebar.tsx
msgid "Tasks"
msgstr "Tasks"

#: src/components/ChannelSettingsModal.tsx
msgid "The #general channel cannot be renamed"
msgstr "The #general channel cannot be renamed"

#: src/components/ProjectMembersPage.tsx
msgid "The agent was added, but the Project member list could not be refreshed."
msgstr "The agent was added, but the Project member list could not be refreshed."

#: src/components/DescriptionEditor.tsx
msgid "The channel description has unsaved changes that will be lost. Leave this page?"
msgstr "The channel description has unsaved changes that will be lost. Leave this page?"

#: src/components/ZoneManagementDialog.tsx
msgid "The name changes in the sidebar and channel breadcrumb. Channel links and access stay the same."
msgstr "The name changes in the sidebar and channel breadcrumb. Channel links and access stay the same."

#: src/components/ProjectMembersPage.tsx
msgid "The Project member list refresh was superseded. Retry refresh to confirm the updated roster."
msgstr "The Project member list refresh was superseded. Retry refresh to confirm the updated roster."

#: src/hooks/useServerTransitionController.ts
msgid "The Project was created, but its channels could not be loaded. Retry switching Projects."
msgstr "The Project was created, but its channels could not be loaded. Retry switching Projects."

#: src/components/CreateChannelDialog.tsx
msgid "The selected Zone is no longer available. Refresh Zones and explicitly choose a location."
msgstr "The selected Zone is no longer available. Refresh Zones and explicitly choose a location."

#: src/components/ZoneManagementDialog.tsx
msgid "The Zone name is invalid."
msgstr "The Zone name is invalid."

#: src/components/ServerMemberRemovalControl.tsx
msgid "This also removes this Human's directly owned Agents from this Project."
msgstr "This also removes this Human's directly owned Agents from this Project."

#: src/lib/readonly.ts
msgid "This channel is read-only. Only its creator can send messages."
msgstr "This channel is read-only. Only its creator can send messages."

#: src/components/ProjectMemberRoleControl.tsx
msgid "This Human will keep Project access without Admin membership authority."
msgstr "This Human will keep Project access without Admin membership authority."

#: src/components/InvitationsInbox.tsx
msgid "This invitation has already been handled or its status has changed. Please refresh."
msgstr "This invitation has already been handled or its status has changed. Please refresh."

#: src/components/ChannelSettingsModal.tsx
msgid "This is a transfer, not a copy. The channel, all threads, messages, tasks, files, authorship, assignments, and activity history keep their IDs and remain complete."
msgstr "This is a transfer, not a copy. The channel, all threads, messages, tasks, files, authorship, assignments, and activity history keep their IDs and remain complete."

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "This name appears in the Project rail and switcher."
msgstr "This name appears in the Project rail and switcher."

#: src/components/ServerSettings/ServerMembersPanel.tsx
msgid "This only removes Project access. It does not remove channel or thread memberships."
msgstr "This only removes Project access. It does not remove channel or thread memberships."

#: src/components/ServerMemberRemovalControl.tsx
msgid "This removes only this Agent's Project membership."
msgstr "This removes only this Agent's Project membership."

#: src/components/ZoneManagementDialog.tsx
msgid "This Zone is no longer available. Refresh Zones to see the current groups."
msgstr "This Zone is no longer available. Refresh Zones to see the current groups."

#: src/components/ZoneManagementDialog.tsx
msgid "This Zone is not empty. Archived channels also prevent deletion. No channels were changed."
msgstr "This Zone is not empty. Archived channels also prevent deletion. No channels were changed."

#. placeholder {0}: topic || t`None`
#: src/components/ChannelStatusCard.tsx
msgid "Topic: {0}"
msgstr "Topic: {0}"

#: src/components/ChannelSettingsModal.tsx
msgid "Type {channelName} to confirm"
msgstr "Type {channelName} to confirm"

#: src/components/CreateChannelDialog.tsx
msgid "Unavailable Zone — choose a location"
msgstr "Unavailable Zone — choose a location"

#: src/components/MuteButton.tsx
msgid "Unmute"
msgstr "Unmute"

#: src/components/ChannelContextMenu.tsx
#: src/components/PinButton.tsx
msgid "Unpin"
msgstr "Unpin"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "Update the name and icon used for this Project."
msgstr "Update the name and icon used for this Project."

#. placeholder {0}: invite.consumed_uses
#. placeholder {1}: invite.max_uses
#: src/components/InviteLinksModal.tsx
msgid "Usage: {0}/{1}"
msgstr "Usage: {0}/{1}"

#: src/lib/zoneNames.ts
msgid "Use 100 characters or fewer."
msgstr "Use 100 characters or fewer."

#: src/components/InviteLinksModal.tsx
msgid "Used up"
msgstr "Used up"

#: src/components/AddMemberModal.tsx
msgid "User email or ID"
msgstr "User email or ID"

#. placeholder {0}: member.display_name
#: src/components/ProjectMembersPage.tsx
msgid "View {0} profile"
msgstr "View {0} profile"

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "View channels you created or joined. Creators can delete their own channels."
msgstr "View channels you created or joined. Creators can delete their own channels."

#: src/components/DescriptionEditor.tsx
msgid "View edit history"
msgstr "View edit history"

#: src/components/ProjectMembersPage.tsx
msgid "View Project profile"
msgstr "View Project profile"

#: src/components/ZoneManagementDialog.tsx
msgid "Virtual · no Zone record"
msgstr "Virtual · no Zone record"

#: src/components/ChannelSettingsModal.tsx
#: src/components/CreateChannelDialog.tsx
msgid "Visibility"
msgstr "Visibility"

#. placeholder {0}: i18n._(label.text)
#: src/components/VisibilityBadge.tsx
msgid "Visibility: {0}"
msgstr "Visibility: {0}"

#: src/components/Settings/ChannelMentionControls.tsx
msgid "Waiting for the current status"
msgstr "Waiting for the current status"

#: src/components/ServerMembersPanel.tsx
msgid "When checked, this agent only responds when @mentioned"
msgstr "When checked, this agent only responds when @mentioned"

#: src/components/ServerSettings/ServerProfilePanel.tsx
msgid "You don’t have permission to update this Project."
msgstr "You don’t have permission to update this Project."

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "You have not created any channels yet."
msgstr "You have not created any channels yet."

#: src/components/Settings/ChannelManagementSurface.tsx
msgid "You have not joined any other channels yet."
msgstr "You have not joined any other channels yet."

#: src/components/ZoneManagementDialog.tsx
msgid "You no longer have permission to manage this Project’s Zones."
msgstr "You no longer have permission to manage this Project’s Zones."

#: src/components/ProjectMembersPage.tsx
msgid "Your active Agents"
msgstr "Your active Agents"

#: src/components/ZoneManagementDialog.tsx
msgid "Your change was saved, but Zones could not be refreshed. Refresh Zones to load the current state."
msgstr "Your change was saved, but Zones could not be refreshed. Refresh Zones to load the current state."

#: src/components/ChannelSettingsModal.tsx
#: src/components/CreateChannelDialog.tsx
msgid "Zone"
msgstr "Zone"

#: src/components/ZoneManagementDialog.tsx
msgid "Zone name"
msgstr "Zone name"

#: src/components/ChannelSettingsModal.tsx
#: src/components/ChannelView.tsx
msgid "Zone unavailable"
msgstr "Zone unavailable"

#. placeholder {0}: group.name
#. placeholder {0}: zone.name
#: src/components/ChannelSettingsModal.tsx
#: src/components/ZoneChannelGroup.tsx
msgid "Zone: {0}"
msgstr "Zone: {0}"

#: src/components/ServerSettings/ServerProfilePanel.tsx
#: src/components/ZoneManagementDialog.tsx
msgid "Zones"
msgstr "Zones"
